import { render, staticRenderFns } from "./HistoryRewardDetail.vue?vue&type=template&id=e216e83c&scoped=true"
import script from "./HistoryRewardDetail.vue?vue&type=script&lang=js"
export * from "./HistoryRewardDetail.vue?vue&type=script&lang=js"
import style0 from "./HistoryRewardDetail.vue?vue&type=style&index=0&id=e216e83c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e216e83c",
  null
  
)

export default component.exports